(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 20394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(91635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _screens_errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52544);
/* harmony import */ var _services_openreplay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92268);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSegment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59945);
/*
 * File: 404.js
 * Project: meki
 * File Created: Saturday, 16th January 2021 10:06:10 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 27th January 2023 2:44:15 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 




function NotFound(props) {
    var trackIssue = (0,_services_openreplay__WEBPACK_IMPORTED_MODULE_2__/* .useOpenReplayTracking */ .WK)().trackIssue;
    var track = (0,_hooks_useSegment__WEBPACK_IMPORTED_MODULE_4__/* .useSegment */ .K)().track;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function trackError() {
        void trackIssue("404 screen", props);
        void track("Error 404");
    }, [
        trackIssue,
        props,
        track
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_errors__WEBPACK_IMPORTED_MODULE_1__/* .ErrorScreen */ .C, {});
}


/***/ }),

/***/ 52544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ ErrorScreen; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/errors/error.styles.ts



var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh"
});
var ErrorContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "fit-content",
    width: "600px"
});
var IconContainer = (0,styled/* default */.Z)("div")({
    position: "relative",
    width: "246px",
    height: "145px",
    marginBottom: "30px"
});
var MainTextContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column"
    }, theme.breakpoints.down(570), {
        padding: "0px 90px"
    });
});
var TextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "30px",
        lineHeight: "45px",
        textAlign: "center",
        color: "#414046"
    }, theme.breakpoints.down(570), {
        fontSize: "16px",
        lineHeight: "24px"
    });
});
var LinkTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "center",
        color: "#0A7ABE",
        textDecoration: "underline",
        cursor: "pointer"
    }, theme.breakpoints.down(570), {
        fontSize: "14px",
        lineHeight: "21px"
    });
});
var SmallTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 300,
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "center",
        color: "#414046"
    }, theme.breakpoints.down(570), {
        fontSize: "14px",
        lineHeight: "21px"
    });
});
var LinkContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "row",
        gap: "6px",
        marginTop: "40px"
    }, theme.breakpoints.down(570), {
        flexDirection: "column",
        gap: "0px"
    });
});


// EXTERNAL MODULE: ./src/screens/home/components/homeNavBar.tsx + 1 modules
var homeNavBar = __webpack_require__(88617);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ./src/screens/errors/error.tsx
/*
 * File: error.tsx
 * Project: meki
 * File Created: Wednesday, 20th January 2021 10:45:04 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Friday, 17th November 2023 4:29:20 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 





var ErrorScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homeNavBar/* HomeNavBar */.y, {
                isVisible: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/images/errorIcon.webp",
                                alt: "error",
                                layout: "fill",
                                objectFit: "contain",
                                priority: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                children: "Ha ocurrido un problema y estamos trabajando para solucionarlo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTypography, {
                                    onClick: function() {
                                        window.open("https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=").concat(encodeURI("Hola! Tuve un problema con la pagina. Necesito ayuda con ")), "_blank");
                                    },
                                    children: "Pincha aqu\xed"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallTypography, {
                                    children: "si quieres recibir ayuda de un asistente"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/errors/index.tsx
/*
 * File: index.tsx
 * Project: meki
 * File Created: Wednesday, 20th January 2021 11:01:16 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Wednesday, 6th October 2021 10:41:56 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(20394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);